// app/error.tsx (Next.js App Router)
'use client';

import { logMessage } from '@/modules/shared/utils';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const router = useRouter();

  useEffect(() => {
    if (error) {
      console.log('Error occured and error is ' + JSON.stringify(error));
      fetch('/api/log-error', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(error),
      });

      const isChunkLoadError =
        error.name === 'ChunkLoadError' ||
        error.message?.includes('Loading chunk');

      // For chunk load → auto hard reload, don’t show scary error page
      if (isChunkLoadError) {
        logMessage('warn', 'ChunkLoadError – reloading page', {
          errorMessage: error.message,
          path: window.location.pathname,
          kind: 'ChunkLoadError',
          referral: document.referrer,
          agent: navigator?.userAgent,
          platform: navigator?.platform,
        });

      window.location.reload();
      } else {
        logMessage('error', 'Client-side error occurred', {
          errorMessage: error.message,
          stack: error.stack,
          path: window.location.pathname,
          referral: document.referrer,
          agent: navigator?.userAgent,
          platform: navigator?.platform,
        });
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className='min-h-screen bg-white flex items-center justify-center'>
      <div className='mx-auto max-w-xl text-center px-6'>
        {/* headline */}
        <h1 className='text-5xl font-semibold tracking-tight text-gray-900'>
          Error occurred
        </h1>

        {/* subcopy */}
        <p className='mt-3 text-gray-500'>
          Something went wrong. Here are some helpful links:
        </p>

        {/* actions */}
        <div className='mt-8 flex items-center justify-center gap-4'>
          <button
            type='button'
            onClick={() => router.back()}
            className='inline-flex items-center gap-2 rounded-2xl border border-gray-200 px-6 py-3 text-gray-900 hover:bg-gray-50 transition'
          >
            <span className='-ml-1'>←</span>
            Go Back
          </button>

          <Link
            href={'/orth?time=' + new Date().getTime()}
            className='inline-flex items-center justify-center rounded-2xl bg-black px-6 py-3 text-white hover:bg-black transition'
            onClick={() => window.location.reload()}
          >
            Go to home
          </Link>
        </div>
      </div>
    </main>
  );
}
